import { FieldValues } from 'react-hook-form';
import { FieldProps } from '../../../../generic/FieldProps';
import { GenericInputField } from '../../../../generic/GenericInputField';
import { BusinessFormInput } from './BusinessFormInput';

export function BusinessFormField<TValues extends FieldValues>(
  props: FieldProps<TValues>
) {
  return (
    <GenericInputField<TValues>
      {...props}
      Input={BusinessFormInput}
      label='Vorname'
    />
  );
}
